export const sizes = {
  small: {
    textSize: 'small',
    subtextSize: 'x-small',
    avatarSize: 'small',
    selectedAvatarSize: 'small',
    dropdownArrowSize: '1.6rem'
  },
  large: {
    height: '3.6rem',
    textSize: 'large',
    subtextSize: 'medium',
    avatarSize: 'medium',
    selectedAvatarSize: 'medium',
    dropdownArrowSize: '2.5rem'
  },
  medium: {
    height: '2.1rem',
    textSize: 'medium',
    subtextSize: 'small',
    avatarSize: 'medium',
    selectedAvatarSize: 'small',
    dropdownArrowSize: '1.6rem'
  }
};
